export default "__VITE_ASSET__pUEVnRn7__"